import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
export function PricingSection() {
  const benefits = ['Acceso inmediato al libro digital', 'Estrategias paso a paso para cada edad', 'Scripts de conversación listos para usar', 'Actividades familiares probadas'];
  return <section id="precio" className="py-20 px-4 bg-gradient-to-b from-white to-orange-50" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <div className="text-center mb-12" data-id="element-44">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-45">
            Invierte en el Futuro Bilingüe de Tus Hijos
          </h2>
          <p className="text-xl text-gray-700" data-id="element-46">
            Una inversión pequeña para un legado que durará toda la vida
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-amber-500" data-id="element-47">
          <div className="bg-gradient-to-r from-orange-500 to-amber-500 p-8 text-center text-white" data-id="element-48">
            <h3 className="text-3xl font-bold mb-2" data-id="element-49">
              ¡MIS HIJOS SÍ HABLARÁN ESPAÑOL!
            </h3>
            <p className="text-lg opacity-90" data-id="element-50">Guía Digital Completa</p>
          </div>

          <div className="p-8 md:p-12" data-id="element-51">
            <div className="text-center mb-8" data-id="element-52">
              <div className="inline-block" data-id="element-53">
                <p className="text-gray-600 text-lg mb-2" data-id="element-54">
                  Precio Especial de Lanzamiento
                </p>
                <div className="flex items-baseline justify-center gap-2" data-id="element-55">
                  <span className="text-5xl md:text-6xl font-bold text-gray-900" data-id="element-56">
                    $11
                  </span>
                  <span className="text-2xl text-gray-600" data-id="element-57">USD</span>
                </div>
                <p className="text-amber-600 font-semibold mt-2" data-id="element-58">
                  Acceso inmediato después del pago
                </p>
              </div>
            </div>

            <div className="mb-8" data-id="element-59">
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-60">
                Lo que recibes:
              </h4>
              <div className="space-y-3" data-id="element-61">
                {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3 bg-green-50 p-4 rounded-lg" data-id="element-62">
                    <CheckIcon className="text-green-600 flex-shrink-0 mt-0.5" size={24} data-id="element-63" />
                    <span className="text-lg text-gray-800" data-id="element-64">{benefit}</span>
                  </div>)}
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-65">
              <CTAButton size="large" isPurchaseButton={true} data-id="element-66">
                Sí, Quiero Esta Guía por $11
              </CTAButton>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-600 text-sm" data-id="element-67">
              <div className="flex items-center gap-2" data-id="element-68">
                <ShieldCheckIcon size={20} className="text-green-600" data-id="element-69" />
                <span data-id="element-70">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-71">
                <CreditCardIcon size={20} className="text-blue-600" data-id="element-72" />
                <span data-id="element-73">Todas las tarjetas aceptadas</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-74">
          <p className="text-gray-600 italic" data-id="element-75">
            Más de 1,000 familias latinas ya están usando este método
          </p>
        </div>
      </div>
    </section>;
}